// src/pages/Immobilier.js
// Page catégorie Immobilier (Parcelles & Propriétés) - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ListingGrid from '../components/listing/ListingGrid';
import CategoryBar from '../components/home/CategoryBar';
import { useListings } from '../hooks/useListings';

const Immobilier = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading } = useListings();
  const [listings, setListings] = useState([]);

  useEffect(() => {
    const demoListings = [
      {
        id: 3,
        slug: 'terrain-viabilise-logpom-3',
        title: 'Terrain viabilisé titre foncier',
        quartier: 'Logpom',
        city: 'Douala',
        price: 25000,
        priceType: 'perSquareMeter',
        category: 'immobilier',
        images: ['/images/placeholder.png'],
        area: 500,
      },
      {
        id: 7,
        slug: 'parcelle-cloturee-ndogpassi-7',
        title: 'Parcelle clôturée bien située',
        quartier: 'Ndogpassi',
        city: 'Douala',
        price: 18000,
        priceType: 'perSquareMeter',
        category: 'immobilier',
        images: ['/images/placeholder.png'],
        area: 800,
      },
    ];
    setListings(demoListings);
  }, []);

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
      padding: '4px',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    subtitle: { padding: '8px 16px', fontSize: '14px', color: '#A0AEC0' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Terrains et propriétés à vendre au Cameroun | Fynho</title>
        <meta name="description" content="Parcelles viabilisées, terrains avec titre foncier et propriétés à vendre au Cameroun." />
        <meta name="keywords" content="terrain à vendre Cameroun, parcelle Douala, titre foncier, terrain viabilisé, propriété Yaoundé" />
        <link rel="canonical" href="https://fynho.com/immobilier" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate('/')}>←</button>
        <div style={styles.title}>🌍 {t('categories.parcelles')}</div>
      </div>

      <CategoryBar />

      <div style={styles.subtitle}>
        Parcelles et propriétés à vendre · {listings.length} annonces
      </div>

      <ListingGrid listings={listings} loading={loading} />
    </div>
  );
};

export default Immobilier;